<template>
  <div>
    <!--未登录全局弹框，用在全局的路由拦截和响应拦截-->
    <Modal class="no-login-box" v-model="noLoginModel" :closable="false" :scrollable="true" :footer-hide="true"
      :mask-closable="false" :styles="{ top: '300px' }" width="300">
      <p class="item-close" @click="noLoginModel = false">
        <img src="/static/img/popup/close.png" alt="" />
      </p>
      <p class="item-img">
        <img src="/static/img/popup/icon_noLogin.png" alt="" />
      </p>
      <p class="item-txt-1">未登录</p>
      <p class="item-txt-2">您还没有登录，请先登录！</p>
      <a class="item-button" @click.prevent="toLogin">去登录</a>
    </Modal>
    <!--未登录弹框-->
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "NoLogin",
  data() {
    return {
      noLoginModel: true,
    };
  },
  methods: {
    toLogin() {
      let vm = this;
      try {
        // vm.next({ path: "/Login" });
        // this.noLoginModel = false;
        window.vm.$router.push({
          path: "/Login"
        });
        this.noLoginModel = false;

      } catch (error) {
      }
    }
  }
};
</script>

<style lang="less" scoped>
.no-login-box {
  text-align: center;

  .item-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -14px;
    top: -25px;
    cursor: pointer;
  }

  .item-img {
    width: 148px;
    height: 81px;
    margin: 37px auto auto auto;
  }

  .item-txt-1 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-top: 18px;
  }

  .item-txt-2 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    padding-top: 6px;
  }

  .item-button {
    display: block;
    width: 250px;
    height: 40px;
    background: linear-gradient(314deg, #53A401 0%, #6AD200 100%);
    box-shadow: 0px 3px 12px 1px rgba(81, 136, 0, 0.3);
    border-radius: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 40px;
    margin: 35px auto auto auto;
  }
}

.no-login-box /deep/ ivu-modal {}

.no-login-box /deep/ .ivu-modal-content {
  position: relative;
  height: 300px;
}</style>



// WEBPACK FOOTER //
// src/components/popup/NoLoginAll.vue